module.exports = __webpack_public_path__ + "img/boat4.3f36cd63.jpg";